export default {
  SET_CLIENTS: 'SET_CLIENTS'
};
